import React from "react";

import { useSelector } from "react-redux"

import logoURL from "img/zeta-logo-nav.png";

import { Navbar, NavItem, Nav, Badge } from "bootstrap-micro";

import { getSessionInfo } from "../store/auth/AuthFilters";
import { useParams } from "react-router-dom";
import { getNotificationCount } from "../store/notificationsSlice.js";

export function AppNav() {
    const { hwaddr } = useParams();
    const unreadNotificationsAndEvents = useSelector(getNotificationCount(hwaddr));
    return <Navbar>
        <Navbar.Header>
            <Navbar.Brand>
                <a className="navbar-brand" href="#"><img className="img-responsive logo" src={logoURL} /></a>
            </Navbar.Brand>
            <Navbar.Toggle />
        </Navbar.Header>
        {
            getSessionInfo().valid
                ?
                <Navbar.Collapse>
                    <Nav>
                        <NavItem href="#/">Site Manager&nbsp;{unreadNotificationsAndEvents > 0 ? <Badge>{unreadNotificationsAndEvents}</Badge> : null}</NavItem>
                        <NavItem href="#account">My Account</NavItem>

                    </Nav>
                    <Nav pullRight >
                        <NavItem href="#logout">Logout</NavItem>
                    </Nav>
                </Navbar.Collapse>
                :
                null
        }
    </Navbar>;
}